import { getEnvironmentVariable } from '../../core/helpers'

const getAutoEatDishReviewTaskUrl = menuId =>
  `${getEnvironmentVariable('REACT_APP_AUTOEAT_WEB_URL')}/tasks/dish-review/from-menu-id/${menuId}`

export default getAutoEatDishReviewTaskUrl
